const radio = require('lib/radio')

function triggerError(err) {
    radio.signup.trigger('error', err)
}

module.exports = triggerError
